import React from "react";
import { Badge } from "react-bootstrap";

const SummaryBar = ({ summary }) => (
  <div className="d-flex justify-content-end mb-3 align-items-center gap-3">
    <div className="text-success fw-bold">
      Running <Badge bg="success">{summary.running}</Badge>
    </div>
    <div className="text-danger fw-bold">
      Stopped <Badge bg="danger">{summary.stopped}</Badge>
    </div>
    
  </div>
);

export default SummaryBar;
